<div>
    Normally you should not see this, authenticated == {{ isAuthenticated }}
  </div>